<app-tabs-main [selectedIndex]="1">
  <div newReservation class="flight-confirmation-container">
    <app-expansion-panel [opened]="true">
      <app-expansion-panel-header>Confirmação do voo</app-expansion-panel-header>
      <app-expansion-panel-body>
        <div class="data-container">
          <div>
            <span class="greeting">Prezado(a) {{ confirmation.crewName }}</span>
            <span class="data-label">Seguem dados da viagem solicitada:</span>
            <div>
              @if (confirmation.outbound) {
                <span class="flight-informations">
                  {{ confirmation.outbound.flightSegments[0].flightNumber }} {{
                  confirmation.outbound.flightSegments[0].originLocationCode}}
                  / {{ confirmation.outbound.flightSegments[0].destinationLocationCode }}
                </span>
              }
              @if (confirmation.outbound) {
                <div class="flight-datetime">
                  {{ confirmation.outbound.flightSegments[0].departureDateTime | dateFormat: 'DD/MM/YYYY'
                  }} {{ confirmation.outbound.flightSegments[0].departureDateTime | dateFormat: 'HH:mm' }}
                  -
                  @if (confirmation.outbound) {
                    <span [ngClass]="{ 'days-diff': confirmation.outbound.flightSegments[0].arrivalDayDiffDepartureDay }">{{ confirmation.outbound.flightSegments[0].arrivalDateTime | dateFormat: 'DD/MM/YYYY' }} {{ confirmation.outbound.flightSegments[0].arrivalDateTime | dateFormat: 'HH:mm' }}</span>
                  }
                </div>
              }

              @if (confirmation.outbound && confirmation.outbound.flightSegments.length > 1) {
                <span class="flight-informations"
                  >
                  {{ confirmation.outbound.flightSegments[1].flightNumber }} {{
                  confirmation.outbound.flightSegments[1].originLocationCode}}
                  / {{ confirmation.outbound.flightSegments[1].destinationLocationCode }}
                </span>
              }
              @if (confirmation.outbound && confirmation.outbound.flightSegments.length > 1) {
                <div class="flight-datetime"
                  >
                  {{ confirmation.outbound.flightSegments[1].departureDateTime | dateFormat: 'DD/MM/YYYY'
                  }} {{ confirmation.outbound.flightSegments[1].departureDateTime | dateFormat: 'HH:mm' }}
                  -
                  @if (confirmation.outbound && confirmation.outbound.flightSegments.length > 1) {
                    <span [ngClass]="{ 'days-diff': confirmation.outbound.flightSegments[1].arrivalDayDiffDepartureDay }">{{ confirmation.outbound.flightSegments[1].arrivalDateTime | dateFormat: 'DD/MM/YYYY' }} {{ confirmation.outbound.flightSegments[1].arrivalDateTime | dateFormat: 'HH:mm' }}</span>
                  }
                </div>
              }

              @if (confirmation.isRoundTrip()) {
                <div>
                  @if (confirmation.inbound) {
                    <span class="flight-informations flight-inbound">
                      {{ confirmation.inbound.flightSegments[0].flightNumber }} {{
                      confirmation.inbound.flightSegments[0].originLocationCode }}
                      / {{ confirmation.inbound.flightSegments[0].destinationLocationCode }}
                    </span>
                  }
                  @if (confirmation.inbound) {
                    <div class="flight-datetime">
                      {{ confirmation.inbound.flightSegments[0].departureDateTime| dateFormat:
                      'DD/MM/YYYY' }} {{ confirmation.inbound.flightSegments[0].departureDateTime |
                      dateFormat: 'HH:mm' }}
                      -
                      @if (confirmation.inbound) {
                        <span [ngClass]="{ 'days-diff': confirmation.inbound.flightSegments[0].arrivalDayDiffDepartureDay }">{{ confirmation.inbound.flightSegments[0].arrivalDateTime | dateFormat: 'DD/MM/YYYY' }} {{ confirmation.inbound.flightSegments[0].arrivalDateTime | dateFormat: 'HH:mm' }}</span>
                      }
                    </div>
                  }
                  @if (confirmation.inbound && confirmation.inbound.flightSegments.length > 1) {
                    <span class="flight-informations flight-inbound"
                      >
                      {{ confirmation.inbound.flightSegments[1].flightNumber }} {{
                      confirmation.inbound.flightSegments[1].originLocationCode }}
                      / {{ confirmation.inbound.flightSegments[1].destinationLocationCode }}
                    </span>
                  }
                  @if (confirmation.inbound && confirmation.inbound.flightSegments.length > 1) {
                    <div class="flight-datetime">
                      {{ confirmation.inbound.flightSegments[1].departureDateTime| dateFormat:
                      'DD/MM/YYYY' }} {{ confirmation.inbound.flightSegments[1].departureDateTime |
                      dateFormat: 'HH:mm' }}
                      -
                      @if (confirmation.inbound && confirmation.inbound.flightSegments.length > 1) {
                        <span [ngClass]="{ 'days-diff': confirmation.inbound.flightSegments[1].arrivalDayDiffDepartureDay }">{{ confirmation.inbound.flightSegments[1].arrivalDateTime | dateFormat: 'DD/MM/YYYY' }} {{ confirmation.inbound.flightSegments[1].arrivalDateTime | dateFormat: 'HH:mm' }}</span>
                      }
                    </div>
                  }
                </div>
              }
            </div>
            <span class="additional-information-label">Informação adicionais:</span>
            <div class="additional-information">
              <ul class="additional-information_list">
                <li>A emissão deste passe representa a intenção de voo, mas não garante: assento,
                  embarque, benefícios e o embarque prioritário em relação a passageiros pagantes e
                funcionários LATAM.</li>
                <li>De acordo com os procedimentos vigentes do SNEA, para o uso do passe é obrigatório
                  portar o uniforme completo da sua empresa e apresentar documento original com foto
                no momento do embarque.</li>
                <li>Bagagens fora do padrão estabelecido pela companhia deverão ser despachadas no check
                in.</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="actions">
          <button class="btn btn-back" (click)="back()">Retornar</button>
          <button class="btn btn-confirmation" (click)="confirmReservation()">Confirmar</button>
        </div>
      </app-expansion-panel-body>

      <ng-template #loading>
        <div class="loading-container">
          <img src="../../../assets/images/plane-loading-100x100.gif" alt="Loading">
        </div>
      </ng-template>

    </app-expansion-panel>
  </div>
</app-tabs-main>